import { ChatForm as DefaultChatForm } from './ChatForm';
import { withState } from './ChatForm.state';

export const ChatForm = withState(DefaultChatForm);
